import getMessage from 'src/background/utils/i18n.utils';
import React, { useEffect, useState } from 'react';
import { AutocompleteBox } from 'src/common-ui/autocomplete/autocomplete-box.component';
import { SVGIcons } from 'src/common-ui/icons.enum';
import { Separator } from 'src/common-ui/separator/separator.component';
import { SVGIcon } from 'src/common-ui/svg-icon/svg-icon.component';
import { FormUtils } from 'src/utils/form.utils';
import { InputType } from './input-type.enum';
const InputComponent = React.forwardRef((props, ref) => {
    var _a, _b, _c, _d;
    const [isFocused, setIsFocused] = useState(false);
    const [isPasswordDisplay, setPasswordDisplayed] = useState(false);
    const [mounted, setMounted] = useState(false);
    useEffect(() => {
        setMounted(true);
        return function cleanup() {
            setMounted(false);
        };
    }, []);
    const handleOnBlur = () => {
        if (mounted) {
            setTimeout(() => setIsFocused(false), 200);
        }
    };
    const handleOnFocus = () => {
        setIsFocused(true);
    };
    return (React.createElement("div", { className: `custom-input ${(_a = props.classname) !== null && _a !== void 0 ? _a : ''}` },
        props.label && (React.createElement("div", { className: "label" },
            props.skipLabelTranslation
                ? props.label
                : getMessage(props.label),
            ' ',
            props.required ? '*' : '',
            props.hint && (React.createElement("div", { className: "hint" }, props.skipHintTranslation
                ? props.hint
                : getMessage(props.hint))))),
        React.createElement("div", { className: `custom-input-content ${props.error ? 'has-error' : ''}` },
            React.createElement("div", { className: `input-container ${props.logo ? `has-${(_b = props.logoPosition) !== null && _b !== void 0 ? _b : 'left'}-logo` : 'no-logo'} ${props.type === InputType.PASSWORD ? 'password-type' : ''} ${isFocused ? 'focused' : ''}` },
                React.createElement("input", { disabled: props.disabled, "data-testid": props.dataTestId, type: props.type === InputType.PASSWORD && isPasswordDisplay
                        ? InputType.TEXT
                        : props.type, ref: ref, placeholder: `${props.placeholder
                        ? props.skipPlaceholderTranslation
                            ? props.placeholder
                            : getMessage(props.placeholder)
                        : ''} ${props.required ? '*' : ''}`, value: props.value, step: props.step, min: props.min, max: props.type === InputType.DATE ? '9999-12-31' : props.max, pattern: props.type === InputType.DATE ? 'yyyy-MM-DD' : undefined, onChange: (e) => props.onChange(e.target.value), onKeyPress: (e) => {
                        if (e.key === 'Enter' && props.onEnterPress) {
                            props.onEnterPress();
                        }
                    }, onFocus: () => handleOnFocus(), onBlur: () => handleOnBlur() }),
                !props.disabled &&
                    props.type === InputType.PASSWORD &&
                    !isPasswordDisplay && (React.createElement(SVGIcon, { icon: SVGIcons.INPUT_SHOW, className: "input-img display-password right", onClick: () => setPasswordDisplayed(true) })),
                !props.disabled &&
                    props.type === InputType.PASSWORD &&
                    isPasswordDisplay && (React.createElement(SVGIcon, { icon: SVGIcons.INPUT_HIDE, className: "input-img display-password right", onClick: () => setPasswordDisplayed(false) })),
                !props.disabled &&
                    ![InputType.PASSWORD, InputType.DATE].includes(props.type) &&
                    props.value &&
                    props.value.length > 0 && (React.createElement(SVGIcon, { dataTestId: "input-clear", icon: SVGIcons.INPUT_CLEAR, className: `input-img erase right ${props.logoPosition === 'right' ? 'has-right-logo' : ''}`, onClick: () => props.onChange('') })),
                isFocused && props.autocompleteValues && (React.createElement(AutocompleteBox, { autoCompleteValues: props.autocompleteValues, handleOnChange: props.onChange, value: props.value })),
                props.logo && (React.createElement(SVGIcon, { icon: props.logo, className: `input-img ${(_c = props.logoPosition) !== null && _c !== void 0 ? _c : 'left'}` }))),
            props.rightActionClicked && props.rightActionIcon && (React.createElement("div", { className: "right-action" },
                React.createElement(Separator, { type: 'vertical' }),
                React.createElement(SVGIcon, { className: `right-action-logo ${(_d = props.rightActionIconClassname) !== null && _d !== void 0 ? _d : ''}`, "data-testid": "right-action", icon: props.rightActionIcon, onClick: props.rightActionClicked })))),
        props.error && (React.createElement("div", { className: "error" }, FormUtils.parseJoiError(props.error)))));
});
export default InputComponent;
